/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchPhotoAdjudication } from './MatchPhotoAdjudication';
import {
    MatchPhotoAdjudicationFromJSON,
    MatchPhotoAdjudicationFromJSONTyped,
    MatchPhotoAdjudicationToJSON,
    MatchPhotoAdjudicationToJSONTyped,
} from './MatchPhotoAdjudication';

/**
 * A stored match screenshot (evidence-only at upload; llmVerdict/adjudication stamped by dispute adjudication)
 * @export
 * @interface EvidenceMatchPhoto
 */
export interface EvidenceMatchPhoto {
    /**
     * 
     * @type {string}
     * @memberof EvidenceMatchPhoto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceMatchPhoto
     */
    assetUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceMatchPhoto
     */
    uploadedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof EvidenceMatchPhoto
     */
    uploadedAt: number;
    /**
     * True if the uploader soft-removed this screenshot from the dispute evidence. Consumer reads (filer view, LLM adjudication) skip detached rows; admin evidence still shows them.
     * @type {boolean}
     * @memberof EvidenceMatchPhoto
     */
    detached?: boolean;
    /**
     * User id that soft-removed the screenshot.
     * @type {string}
     * @memberof EvidenceMatchPhoto
     */
    detachedBy?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof EvidenceMatchPhoto
     */
    llmVerdict?: { [key: string]: any; };
    /**
     * 
     * @type {MatchPhotoAdjudication}
     * @memberof EvidenceMatchPhoto
     */
    adjudication?: MatchPhotoAdjudication;
}

/**
 * Check if a given object implements the EvidenceMatchPhoto interface.
 */
export function instanceOfEvidenceMatchPhoto(value: object): value is EvidenceMatchPhoto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('uploadedAt' in value) || value['uploadedAt'] === undefined) return false;
    return true;
}

export function EvidenceMatchPhotoFromJSON(json: any): EvidenceMatchPhoto {
    return EvidenceMatchPhotoFromJSONTyped(json, false);
}

export function EvidenceMatchPhotoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvidenceMatchPhoto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assetUrl': json['assetUrl'] == null ? undefined : json['assetUrl'],
        'uploadedBy': json['uploadedBy'] == null ? undefined : json['uploadedBy'],
        'uploadedAt': json['uploadedAt'],
        'detached': json['detached'] == null ? undefined : json['detached'],
        'detachedBy': json['detachedBy'] == null ? undefined : json['detachedBy'],
        'llmVerdict': json['llmVerdict'] == null ? undefined : json['llmVerdict'],
        'adjudication': json['adjudication'] == null ? undefined : MatchPhotoAdjudicationFromJSON(json['adjudication']),
    };
}

export function EvidenceMatchPhotoToJSON(json: any): EvidenceMatchPhoto {
    return EvidenceMatchPhotoToJSONTyped(json, false);
}

export function EvidenceMatchPhotoToJSONTyped(value?: EvidenceMatchPhoto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assetUrl': value['assetUrl'],
        'uploadedBy': value['uploadedBy'],
        'uploadedAt': value['uploadedAt'],
        'detached': value['detached'],
        'detachedBy': value['detachedBy'],
        'llmVerdict': value['llmVerdict'],
        'adjudication': MatchPhotoAdjudicationToJSON(value['adjudication']),
    };
}

